<div class="min-vh-100 py-4 d-flex align-items-center justify-content-center">
    @let registerData = registerData$ | async;
    @let lockUp = lockUp$ | async;
    @let pending = pending$ | async;

    @if (pending$ | async) {
        <app-spinner></app-spinner>
    } @else {
        <div class="d-flex align-items-center justify-content-center flex-column">
            <mat-card class="mat-mdc-elevation-specific mat-elevation-z0 rounded-lg">
                <mat-card-content class="px-5">
                    <form class="register-confirm-form" [formGroup]="form">
                        <h1 class="page-title">
                            {{ 'auth.register.confirm_page_title' | translate }}
                        </h1>
                        @if (registerData) {
                            <div class="text-primary-color">
                                @if (registerData.sysCode === systemChannelCode.Sms) {
                                    <span>{{ 'auth.confirm.code_sent' | translate: { phone: registerData.phone | phoneFormat } }}</span>
                                }
                                @if (registerData.sysCode === systemChannelCode.Email) {
                                    <span>{{ 'auth.confirm.code_sent'| translate: { phone: registerData.email } }}</span>
                                }
                            </div>
                        }

                        <app-form-error [error]="error$ | async" />

                        <div class="code-field-container">
                            <mat-form-field class="field">
                                <mat-label>{{ 'app.form.labels.code' | translate }}</mat-label>
                                <input matInput
                                       type="text"
                                       placeholder="0000"
                                       [imask]="{ mask: '0000' }"
                                       minlength="4"
                                       maxlength="4"
                                       [formControlName]="registerConfirmFormField.Code"
                                       required
                                       autocomplete="off" />

                            </mat-form-field>

                            @if (form.touched && codeControl.hasError('required')) {
                                <mat-error class="error">{{ 'auth.errors.code_required' | translate }}</mat-error>
                            }

                            <mat-panel-description class="d-block">
                                @if (lockUp) {
                                    <small class="resend-message" role="timer">
                                        {{ 'auth.confirm.resend_timeout'| translate: { time: lockUp | lockupTime } }}
                                    </small>
                                }
                            </mat-panel-description>
                        </div>

                        <div class="d-flex justify-content-between mt-6">
                            <button mat-raised-button
                                    color="primary"
                                    class="mat-elevation-z0 mat-mdc-elevation-specific"
                                    [disabled]="form.invalid || pending"
                                    (click)="confirmRegistration()">{{ 'app.actions.confirm' | translate }}

                            </button>

                            <button mat-raised-button
                                    class="mat-elevation-z0 mat-mdc-elevation-specific"
                                    [disabled]="pending || lockUp > 0"
                                    (click)="resendCode()">{{ 'app.actions.resend' | translate }}
                            </button>
                        </div>
                    </form>
                </mat-card-content>
            </mat-card>
        </div>
    }
</div>
